export const BACKGROUND = {
	BASE: {
		100: 'rgba(244, 242, 237, 1)',
		80: 'rgba(244, 242, 237, 0.8)',
		72: 'rgba(244, 242, 237, 0.72)',
		60: 'rgba(244, 242, 237, 0.6)',
	},
	PRIMARY: {
		100: 'rgba(255, 255, 255, 1)',
		80: 'rgba(255, 255, 255, 0.8)',
		72: 'rgba(255, 255, 255, 0.72)',
		60: 'rgba(255, 255, 255, 0.6)',
	},
};

export const TEXT = {
	PRIMARY: 'rgba(0, 0, 0, 0.88)',
	SECONDARY: 'rgba(0, 0, 0, 0.72)',
	TERTIARY: 'rgba(0, 0, 0, 0.6)',
	QUATERNARY: 'rgba(0, 0, 0, 0.36)',
};

export const STROKE = {
	PRIMARY: 'rgba(0, 0, 0, 0.12)',
	SECONDARY: 'rgba(0, 0, 0, 0.08)',
	TERTIARY: 'rgba(0, 0, 0, 0.04)',
};

export const PEARL = {
	BASE: {
		50: 'rgba(244, 242, 237, 1)',
		100: 'rgba(220, 218, 213, 1)',
		200: 'rgba(195, 194, 190, 1)',
		300: 'rgba(171, 169, 166, 1)',
		400: 'rgba(146, 145, 142, 1)',
		500: 'rgba(122, 121, 119, 1)',
		600: 'rgba(98, 97, 95, 1)',
		700: 'rgba(73, 73, 71, 1)',
		800: 'rgba(49, 48, 47, 1)',
		900: 'rgba(36, 36, 35, 1)',
		950: 'rgba(30, 29, 29, 1)',
	},
	PRIMARY: 'rgba(122, 121, 119, 0.2)',
	SECONDARY: 'rgba(122, 121, 119, 0.16)',
	TERTIARY: 'rgba(122, 121, 119, 0.12)',
	QUATERNARY: 'rgba(122, 121, 119, 0.08)',
};

export const PRIMARY = {
	BASE: 'rgba(106, 176, 186, 1)',
	LIGHT: {
		16: '#82bdc5',
		32: '#9ac9d0',
		48: '#b1d6db',
	},
	DARK: {
		16: '#59949c',
		32: '#48777e',
		48: '#375c61',
	},
	PRIMARY: 'rgba(106, 176, 186, 0.2)',
	SECONDARY: 'rgba(106, 176, 186, 0.16)',
	TERTIARY: 'rgba(106, 176, 186, 0.12)',
	QUATERNARY: 'rgba(106, 176, 186, 0.08)',
};

export const GREEN = {
	BASE: 'rgba(61, 186, 103, 1)',
	LIGHT: {
		16: '#5CC57F',
		32: '#7BD098',
		48: '#9ADBB0',
	},
	DARK: {
		16: 'rgba(51, 156, 86, 1)',
		32: '#297E46',
		48: '#206136',
	},
	PRIMARY: 'rgba(61, 186, 103, 0.2)',
	SECONDARY: 'rgba(61, 186, 103, 0.16)',
	TERTIARY: 'rgba(61, 186, 103, 0.12)',
	QUATERNARY: 'rgba(61, 186, 103, 0.08)',
};

export const ORANGE = {
	BASE: 'rgba(235, 148, 33, 1)',
	LIGHT: {
		16: '#EEA545',
		32: '#F1B668',
		48: '#F5C78B',
	},
	DARK: {
		16: 'rgba(197, 124, 28, 1)',
		32: '#9F6416',
		48: '#7B4D11',
	},
	PRIMARY: 'rgba(235, 148, 33, 0.2)',
	SECONDARY: 'rgba(235, 148, 33, 0.16)',
	TERTIARY: 'rgba(235, 148, 33, 0.12)',
	QUATERNARY: 'rgba(235, 148, 33, 0.08)',
};

export const RED = {
	BASE: 'rgba(214, 69, 38, 1)',
	LIGHT: {
		16: '#DD6349',
		32: '#E3816C',
		48: '#EA9E8E',
	},
	DARK: {
		16: 'rgba(180, 58, 32, 1)',
		32: '#912F1A',
		48: '#702414',
	},
	PRIMARY: 'rgba(214, 69, 38, 0.2)',
	SECONDARY: 'rgba(214, 69, 38, 0.16)',
	TERTIARY: 'rgba(214, 69, 38, 0.12)',
	QUATERNARY: 'rgba(214, 69, 38, 0.08)',
};
